/**
 * Portal Manta · LinhaRelatorio
 * Extraído de App.jsx (v29 modular)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { M, F, STATUS } from '../../tokens/theme.js';

const LinhaRelatorio = memo(function LinhaRelatorio_Inner({r, onAbrirPreview, previewAtivo}){
  const tdStl = {
    padding:'6px 10px', borderTop:`1px solid #F3F4F6`, fontSize:11.5,
    color:M.text, verticalAlign:'middle',
    opacity: r.disabled ? 0.5 : 1,
  };
  return (<tr style={{
    background: previewAtivo ? '#FEF3C7' : '#fff',
    transition: 'background .15s ease',
  }}>
    <td style={{...tdStl, textAlign:'center', fontSize:16, width:36}}>{r.ic}</td>
    <td style={{...tdStl, fontFamily:F.mono, fontWeight:700, color:M.accent, fontSize:11, width:46}}>
      {r.id}
    </td>
    <td style={tdStl}>
      <div style={{fontFamily:F.display, fontSize:12, fontWeight:700, color:M.title}}>
        {r.titulo}
      </div>
      <div style={{fontSize:10.5, color:M.muted, marginTop:1, lineHeight:1.35}}>
        {r.desc}
      </div>
    </td>
    <td style={{...tdStl, fontFamily:F.mono, fontSize:10, color:M.muted, width:90, whiteSpace:'nowrap'}}>
      {r.fmt}
    </td>
    <td style={{...tdStl, textAlign:'right', width:130, whiteSpace:'nowrap'}}>
      <button onClick={onAbrirPreview} disabled={r.disabled} title="Visualizar no painel direito" style={{
        padding:'4px 8px', marginRight:4,
        background: previewAtivo ? M.accent : (r.disabled ? '#E5E7EB' : '#1F2937'),
        color: r.disabled ? '#9CA3AF' : '#fff', border:'none', borderRadius:3,
        fontFamily:F.mono, fontSize:10, fontWeight:700, letterSpacing:.3,
        cursor: r.disabled ? 'not-allowed' : 'pointer',
      }}>👁</button>
      <button onClick={r.fn} disabled={r.disabled} title={`Baixar ${r.fmt}`} style={{
        padding:'4px 8px',
        background: r.disabled ? '#E5E7EB' : M.accent,
        color: r.disabled ? '#9CA3AF' : '#fff', border:'none', borderRadius:3,
        fontFamily:F.mono, fontSize:10, fontWeight:700, letterSpacing:.3,
        cursor: r.disabled ? 'not-allowed' : 'pointer',
      }}>⬇</button>
    </td>
  </tr>);
});

export { LinhaRelatorio };
export default LinhaRelatorio;
